import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import { Modal, Input, Form } from 'antd';

// const App = () => {
//   const [visible, setVisible] = React.useState(false);
//   const [confirmLoading, setConfirmLoading] = React.useState(false);
//   const [modalText, setModalText] = React.useState('Content of the modal');

class MessageModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            input: {},
            errors: {}
        }
    }
    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;
        if (!input["email"] || input["email"] == "") {
            isValid = false;
            errors["email"] = "Please enter an email Address.";
        } else {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(input["email"])) {
                isValid = false;
                errors["email"] = "Please enter valid email address.";
            }
        }
        this.setState({
            errors: errors
        });

        return isValid;
    }
    handleOk = (event) => {
        event.preventDefault();
        if (this.validate()) {
            this.state.errors["email"] = '';
            //send email api call
            console.log(this.state.input["email"], "email address")
            this.setState({
                visible: false,
            }, () => { this.props.onHandleCancel(false, true, this.state.input["email"]) });
        }
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            errors: {}
        }, () => { this.props.onHandleCancel(false, false, '') });
    };

    componentDidUpdate(prevProp, prevState) {
        if (this.props.visible !== undefined && this.props.visible !== prevProp.visible) {
            let input = this.state.input;
            input["email"] = this.props.email !== "" ? this.props.email : ""
            this.setState(
                {
                    visible: this.props.visible,
                    input
                }
            );
        }
    }
    handleEmail = (event) => {
        // console.log(event.target.value, "email address")
        // this.setState({
        //     input: event.target.value
        // })
        let errors = {};
        errors["email"] = "";
        let input = this.state.input;
        input["email"] = event.target.value;
        this.setState({
            input,
            errors: errors
        });
    }
    render() {

        return (
            <Modal
                title={this.props.modalTitle}
                visible={this.state.visible}
                onOk={this.handleOk}
                okText="Confirm"
                onCancel={this.handleCancel}
                destroyOnClose={true}
            >
                <p>Due to the extended search range selected, your file will be processed and sent to the email address you list below.</p>
                <Form
                    layout="vertical"
                    name="form_in_modal"
                    // ref={this.formRef}
                    initialValues={{
                        modifier: 'public',
                    }}
                    preserve={false}
                >

                    <Form.Item
                        label="Email Address"
                        value={this.state.input.email}
                        onChange={this.handleEmail}
                    >
                        <Input name="email" defaultValue={this.props.email !== "" ? this.props.email : ""} />
                        <div className="text-danger">{this.state.errors.email}</div>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
};

export default MessageModal;